import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import LoginPage from 'pages/Auth';
import ReviewsPage from 'pages/unauthorized/Reviews';
import ExpertOpinion from 'pages/unauthorized/ExpertOpinion';
import KnowledgeSlices from 'pages/unauthorized/KnowledgeSlices';
import Schools from 'pages/unauthorized/Schools';
import DigitalSchool from 'pages/unauthorized/DigitalSchool';
import Olympiads from 'pages/unauthorized/Olympiads';
import Courses from 'pages/unauthorized/Courses';
import Webinars from 'pages/unauthorized/Webinars';
import PdfViewPage from 'pages/unauthorized/PdfView';
import BannersContext from 'features/shared/Banners/BannersContext';

const UnauthApp = () => {
  return (
    <BannersContext unauthorized>
      <Switch>
        <Route path={'/login'} component={LoginPage} />
        {/* <Route path={'/reviews/*'} component={ReviewsPage} /> */}
        <Route path={'/expert_opinion'} component={ExpertOpinion} />
        <Route path={'/knowledge_slices'} component={KnowledgeSlices} />
        <Route path={'/schools'} component={Schools} />
        <Route path={'/olympiads'} component={Olympiads} />
        <Route path={'/courses'} component={Courses} />
        <Route path={'/webinars'} component={Webinars} />
        <Route path={'/cabinetmunicipaliteta/:subject_id/memo'} component={PdfViewPage} />
        <Redirect to="/login" />
      </Switch>
    </BannersContext>
  );
};

export default UnauthApp;
